/** 문턱 오름차순. 이 순서가 계약이다 — 테스트가 고정한다. */
export const MEMBER_TIERS = [
    { key: 'troller', label: '트롤러', emoji: '🫘', minComments: 0, blurb: '일단 와서 구경하쇼' },
    { key: 'good_boy', label: '우쭈쭈', emoji: '🌱', minComments: 1, blurb: '그래그래, 잘하고 있어' },
    { key: 'money_eyes', label: '공돈환장', emoji: '🌸', minComments: 10, blurb: '돈이라면 눈이 돌아간다' },
    { key: 'syndicate', label: '신디케이트', emoji: '🍎', minComments: 50, blurb: '지원금판의 큰손들' },
];
/**
 * 활동량 → 등급.
 *
 * 지금은 댓글 수 하나로 정한다. 이 제품에서 회원이 만드는 것이 댓글뿐이라
 * 다른 지표를 넣으면 지어내는 것이 된다. 기여의 종류가 늘면 그때 늘린다.
 */
export function memberTier(activity) {
    const i = MEMBER_TIERS.reduce((acc, t, idx) => (activity.comments >= t.minComments ? idx : acc), 0);
    const tier = MEMBER_TIERS[i];
    const upcoming = MEMBER_TIERS[i + 1];
    return {
        ...tier,
        // 다음 등급이 안 보이면 등급은 그냥 딱지다. 얼마나 남았는지 말해 준다.
        next: upcoming
            ? {
                label: upcoming.label,
                emoji: upcoming.emoji,
                remaining: upcoming.minComments - activity.comments,
            }
            : null,
    };
}
//# sourceMappingURL=member-tier.js.map